export default "/_next/static/videos/17c7584261b2c6793d115bafdc6ba8d3.mp4";